import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
  FaPinterestP,
  FaWhatsapp,
} from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { SlSocialYoutube } from "react-icons/sl";
import CommonModal from "../modal/CommonModal";
import { apiBaseUrl } from "../../config";
import { useSelector } from "react-redux";

const TermsCondition = ({ userId }) => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const hasFetched = useRef(false);
  const userData = useSelector((state) => state.fetchUser?.user?.services);

  useEffect(() => {
    const links = document.querySelectorAll(".terms-list a");

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        links.forEach((l) => l.classList.remove("active"));
        link.classList.add("active");
      });
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener("click", () => {});
      });
    };
  }, [policies]);

  useEffect(() => {
    if (!hasFetched.current && userId) {
      hasFetched.current = true;
      fetchPolicies();
    }
  }, [userId]); // Depend on userId

  const fetchPolicies = async () => {
    // console.log("Fetching policies for user:", userId);

    if (!userId) {
      setError("User ID is missing");
      console.error("User ID is missing");
      return;
    }

    try {
      const response = await fetch(
        `${apiBaseUrl}policy/get-all-policies/${userId}`
      );
      const data = await response.json();

      if (response.ok) {
        setPolicies(data.policies);
      } else {
        setError(data.error || "Failed to fetch policies");
      }
    } catch (err) {
      setError("Error fetching policies");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleShowModal = (policy) => {
    setSelectedPolicy(policy);
    setShowModal(true);
  };

  return (
    <div className="terms-container">
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : policies.length === 0 ? (
        <p>No active policies found.</p>
      ) : (
        <>
          <ul className="terms-list">
            {policies.map((policy, index) => (
              <li key={index}>
                <Link onClick={() => handleShowModal(policy)}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: policy.policy_type || "No Policy Type",
                    }}
                  ></span>
                </Link>
              </li>
            ))}
          </ul>
          {/* Add the wavy line here */}
          <div className="wavy-lines">
            <svg viewBox="0 0 117 14" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_47_6274)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M-48 6.97727C-45.271 6.97727 -43.7473 8.38637 -42.2008 9.77274C-40.8591 11 -39.54 12.2273 -37.3568 12.2273C-35.1736 12.2273 -33.8318 11 -32.4901 9.77274C-30.9664 8.38637 -29.4199 6.97727 -26.6909 6.97727C-23.9846 6.97727 -22.4382 8.38637 -20.9145 9.77274C-19.5727 11 -18.2309 12.2273 -16.0477 12.2273C-13.8645 12.2273 -12.5455 11 -11.2037 9.77274C-9.65727 8.38637 -8.13356 6.97727 -5.40454 6.97727C-2.67553 6.97727 -1.12908 8.38637 0.394623 9.77274C1.73639 11 3.07816 12.2273 5.23863 12.2273C7.42184 12.2273 8.76362 11 10.1054 9.77274C11.6291 8.38637 13.1755 6.97727 15.9045 6.97727C18.6336 6.97727 20.1573 8.38637 21.7037 9.77274C23.0455 11 24.3645 12.2273 26.5477 12.2273C28.7309 12.2273 30.0727 11 31.3917 9.77274C32.9382 8.38637 34.4846 6.97727 37.1909 6.97727C39.9199 6.97727 41.4664 8.38637 42.9901 9.77274C44.3318 11 45.6736 12.2273 47.8568 12.2273C50.04 12.2273 51.3591 11 52.7008 9.77274C54.2473 8.38637 55.771 6.97727 58.5 6.97727C61.229 6.97727 62.7527 8.38637 64.2992 9.77274C65.6409 11 66.96 12.2273 69.1432 12.2273C71.3264 12.2273 72.6682 11 74.0099 9.77274C75.5336 8.38637 77.0801 6.97727 79.8091 6.97727C82.5154 6.97727 84.0618 8.38637 85.6083 9.77274C86.9273 11 88.2691 12.2273 90.4523 12.2273C92.6355 12.2273 93.9545 11 95.2963 9.77274C96.8427 8.38637 98.3892 6.97727 101.095 6.97727C103.824 6.97727 105.371 8.38637 106.895 9.77274C108.236 11 109.578 12.2273 111.761 12.2273C113.922 12.2273 115.264 11 116.605 9.77274C118.129 8.38637 119.676 6.97727 122.405 6.97727C125.134 6.97727 126.657 8.38637 128.204 9.77274C129.545 11 130.865 12.2273 133.048 12.2273C135.231 12.2273 136.573 11 137.914 9.77274C139.438 8.38637 140.985 6.97727 143.691 6.97727C146.42 6.97727 147.966 8.38637 149.49 9.77274C150.832 11 152.174 12.2273 154.357 12.2273C156.54 12.2273 157.859 11 159.201 9.77274C160.747 8.38637 162.271 6.97727 165 6.97727V8.25001C162.771 8.25001 161.407 9.47727 160.065 10.7273C158.541 12.1136 157.018 13.5 154.357 13.5C151.696 13.5 150.172 12.1136 148.649 10.7273C147.284 9.47727 145.942 8.25001 143.691 8.25001C141.462 8.25001 140.12 9.47727 138.756 10.7273C137.232 12.1136 135.709 13.5 133.048 13.5C130.387 13.5 128.863 12.1136 127.34 10.7273C125.998 9.47727 124.633 8.25001 122.405 8.25001C120.176 8.25001 118.811 9.47727 117.47 10.7273C115.946 12.1136 114.422 13.5 111.761 13.5C109.078 13.5 107.554 12.1136 106.03 10.7273C104.689 9.47727 103.347 8.25001 101.095 8.25001C98.8667 8.25001 97.5022 9.47727 96.1605 10.7273C94.6368 12.1136 93.1131 13.5 90.4523 13.5C87.7915 13.5 86.2678 12.1136 84.7441 10.7273C83.3796 9.47727 82.0378 8.25001 79.8091 8.25001C77.5577 8.25001 76.2159 9.47727 74.8514 10.7273C73.3277 12.1136 71.8267 13.5 69.1432 13.5C66.4824 13.5 64.9587 12.1136 63.435 10.7273C62.0932 9.47727 60.7287 8.25001 58.5 8.25001C56.2713 8.25001 54.9068 9.47727 53.565 10.7273C52.0413 12.1136 50.5176 13.5 47.8568 13.5C45.1733 13.5 43.6723 12.1136 42.1486 10.7273C40.7841 9.47727 39.4423 8.25001 37.1909 8.25001C34.9622 8.25001 33.6204 9.47727 32.2559 10.7273C30.7322 12.1136 29.2085 13.5 26.5477 13.5C23.8869 13.5 22.3632 12.1136 20.8395 10.7273C19.4978 9.47727 18.1332 8.25001 15.9045 8.25001C13.6531 8.25001 12.3113 9.47727 10.9696 10.7273C9.44587 12.1136 7.92216 13.5 5.23863 13.5C2.57784 13.5 1.05413 12.1136 -0.46957 10.7273C-1.81134 9.47727 -3.17585 8.25001 -5.40454 8.25001C-7.63324 8.25001 -8.99776 9.47727 -10.3395 10.7273C-11.8632 12.1136 -13.3869 13.5 -16.0477 13.5C-18.7085 13.5 -20.2322 12.1136 -21.7559 10.7273C-23.1204 9.47727 -24.4622 8.25001 -26.6909 8.25001C-28.9423 8.25001 -30.2841 9.47727 -31.6486 10.7273C-33.1723 12.1136 -34.6733 13.5 -37.3568 13.5C-40.0176 13.5 -41.5413 12.1136 -43.065 10.7273C-44.4068 9.47727 -45.7713 8.25001 -48 8.25001V6.97727ZM-42.2008 3.31819C-40.8591 4.54546 -39.54 5.77273 -37.3568 5.77273C-35.1736 5.77273 -33.8318 4.54546 -32.4901 3.31819C-30.9664 1.9091 -29.4199 0.5 -26.6909 0.5C-23.9846 0.5 -22.4382 1.9091 -20.9145 3.31819C-19.5727 4.54546 -18.2309 5.77273 -16.0477 5.77273C-13.8645 5.77273 -12.5455 4.54546 -11.2037 3.31819C-9.65727 1.9091 -8.13356 0.5 -5.40454 0.5C-2.67553 0.5 -1.12908 1.9091 0.394623 3.31819C1.73639 4.54546 3.07816 5.77273 5.23863 5.77273C7.42184 5.77273 8.76362 4.54546 10.1054 3.31819C11.6291 1.9091 13.1755 0.5 15.9045 0.5C18.6336 0.5 20.1573 1.9091 21.7037 3.31819C23.0455 4.54546 24.3645 5.77273 26.5477 5.77273C28.7309 5.77273 30.0727 4.54546 31.3917 3.31819C32.9382 1.9091 34.4846 0.5 37.1909 0.5C39.9199 0.5 41.4664 1.9091 42.9901 3.31819C44.3318 4.54546 45.6736 5.77273 47.8568 5.77273C50.04 5.77273 51.3591 4.54546 52.7008 3.31819C54.2473 1.9091 55.771 0.5 58.5 0.5C61.229 0.5 62.7527 1.9091 64.2992 3.31819C65.6409 4.54546 66.96 5.77273 69.1432 5.77273C71.3264 5.77273 72.6682 4.54546 74.0099 3.31819C75.5336 1.9091 77.0801 0.5 79.8091 0.5C82.5154 0.5 84.0618 1.9091 85.6083 3.31819C86.9273 4.54546 88.2691 5.77273 90.4523 5.77273C92.6355 5.77273 93.9545 4.54546 95.2963 3.31819C96.8427 1.9091 98.3892 0.5 101.095 0.5C103.824 0.5 105.371 1.9091 106.895 3.31819C108.236 4.54546 109.578 5.77273 111.761 5.77273C113.922 5.77273 115.264 4.54546 116.605 3.31819C118.129 1.9091 119.676 0.5 122.405 0.5C125.134 0.5 126.657 1.9091 128.204 3.31819C129.545 4.54546 130.865 5.77273 133.048 5.77273C135.231 5.77273 136.573 4.54546 137.914 3.31819C139.438 1.9091 140.985 0.5 143.691 0.5C146.42 0.5 147.966 1.9091 149.49 3.31819C150.832 4.54546 152.174 5.77273 154.357 5.77273C156.54 5.77273 157.859 4.54546 159.201 3.31819C160.747 1.9091 162.271 0.5 165 0.5V1.79546C162.771 1.79546 161.407 3.02273 160.065 4.25C158.541 5.65909 157.018 7.04546 154.357 7.04546C151.696 7.04546 150.172 5.65909 148.649 4.25C147.284 3.02273 145.942 1.79546 143.691 1.79546C141.462 1.79546 140.12 3.02273 138.756 4.25C137.232 5.65909 135.709 7.04546 133.048 7.04546C130.387 7.04546 128.863 5.65909 127.34 4.25C125.998 3.02273 124.633 1.79546 122.405 1.79546C120.176 1.79546 118.811 3.02273 117.47 4.25C115.946 5.65909 114.422 7.04546 111.761 7.04546C109.078 7.04546 107.554 5.65909 106.03 4.25C104.689 3.02273 103.347 1.79546 101.095 1.79546C98.8667 1.79546 97.5022 3.02273 96.1605 4.25C94.6368 5.65909 93.1131 7.04546 90.4523 7.04546C87.7915 7.04546 86.2678 5.65909 84.7441 4.25C83.3796 3.02273 82.0378 1.79546 79.8091 1.79546C77.5577 1.79546 76.2159 3.02273 74.8514 4.25C73.3277 5.65909 71.8267 7.04546 69.1432 7.04546C66.4824 7.04546 64.9587 5.65909 63.435 4.25C62.0932 3.02273 60.7287 1.79546 58.5 1.79546C56.2713 1.79546 54.9068 3.02273 53.565 4.25C52.0413 5.65909 50.5176 7.04546 47.8568 7.04546C45.1733 7.04546 43.6723 5.65909 42.1486 4.25C40.7841 3.02273 39.4423 1.79546 37.1909 1.79546C34.9622 1.79546 33.6204 3.02273 32.2559 4.25C30.7322 5.65909 29.2085 7.04546 26.5477 7.04546C23.8869 7.04546 22.3632 5.65909 20.8395 4.25C19.4978 3.02273 18.1332 1.79546 15.9045 1.79546C13.6531 1.79546 12.3113 3.02273 10.9696 4.25C9.44587 5.65909 7.92216 7.04546 5.23863 7.04546C2.57784 7.04546 1.05413 5.65909 -0.46957 4.25C-1.81134 3.02273 -3.17585 1.79546 -5.40454 1.79546C-7.63324 1.79546 -8.99776 3.02273 -10.3395 4.25C-11.8632 5.65909 -13.3869 7.04546 -16.0477 7.04546C-18.7085 7.04546 -20.2322 5.65909 -21.7559 4.25C-23.1204 3.02273 -24.4622 1.79546 -26.6909 1.79546C-28.9423 1.79546 -30.2841 3.02273 -31.6486 4.25C-33.1723 5.65909 -34.6733 7.04546 -37.3568 7.04546C-40.0176 7.04546 -41.5413 5.65909 -43.065 4.25C-44.4068 3.02273 -45.7713 1.79546 -48 1.79546V0.5C-45.271 0.5 -43.7473 1.9091 -42.2008 3.31819Z"
                  fill="#E8DFE0"
                />
              </g>
              <defs>
                <clipPath id="clip0_47_6274">
                  <rect width="117" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </>
      )}

      {/* Wavy separator */}
      <div className="social">
        {userData?.find(
          (service) => service.title.toLowerCase() === "instagram"
        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "instagram"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "facebook"
        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "facebook"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "whatsapp"
        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "whatsapp"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "youtube"
       )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "youtube"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialYoutube />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "email"
        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "email"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaEnvelope />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "pinterest"
        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "pinterest"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaPinterestP />
          </Link>
        )}
        {userData?.find(
          (service) => service.title.toLowerCase() === "mobile"

        )?.content && (
          <Link
            className="social-icons"
            to={
              userData.find(
                (service) => service.title.toLowerCase() === "mobile"
              ).content
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiPhone />
          </Link>
        )}
      </div>

      {/* Modal for showing policy details */}
      {selectedPolicy && (
        <CommonModal
          show={showModal}
          onHide={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: selectedPolicy.policy_header || "No Header",
              }}
            ></span>
          }
          content={
            <div
              dangerouslySetInnerHTML={{
                __html:
                  selectedPolicy.policy_description || "No description available",
              }}
            ></div>
          }
        />
      )}
    </div>
  );
};

export default TermsCondition;
